import React from 'react';
import Layout from '../components/layout/Layout';

const ShippingPage = () => {
  return (
    <Layout>
      <section className="pt-24 md:pt-32 pb-12 md:pb-16 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">Shipping Policy</h1>
          <p className="text-gray-300">Last updated: January 2025</p>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">1. Shipping Coverage</h2>
          <p className="text-gray-600 mb-6">
            STEAM-IE delivers robotics and coding kits across India. We currently ship to all states 
            and union territories. For international shipping inquiries, please contact us at 
            info@steamie.net.
          </p>

          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">2. Shipping Charges</h2>
          <p className="text-gray-600 mb-4">Shipping charges are calculated based on the delivery location:</p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li><strong>Metro Cities:</strong> FREE shipping on all orders</li>
            <li><strong>Tier 2 & 3 Cities:</strong> FREE shipping on orders above ₹5,000</li>
            <li><strong>Remote Areas:</strong> Nominal charges may apply (displayed at checkout)</li>
            <li><strong>Bulk Orders (Schools/Institutions):</strong> FREE shipping across India</li>
          </ul>

          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">3. Processing Time</h2>
          <p className="text-gray-600 mb-6">
            Orders are processed within 1-2 business days after payment confirmation. You will receive 
            an email with tracking details once your order is dispatched. Orders placed on weekends or 
            holidays will be processed on the next business day.
          </p>

          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">4. Delivery Timeline</h2>
          <p className="text-gray-600 mb-4">Estimated delivery times after dispatch:</p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li><strong>Metro Cities:</strong> 3-5 business days</li>
            <li><strong>Tier 2 Cities:</strong> 5-7 business days</li>
            <li><strong>Tier 3 Cities & Rural Areas:</strong> 7-10 business days</li>
            <li><strong>Remote/Difficult Terrain:</strong> 10-15 business days</li>
          </ul>

          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">5. Shipping Partners</h2>
          <p className="text-gray-600 mb-6">
            We partner with reputed courier services including BlueDart, Delhivery, DTDC, and India Post 
            to ensure safe and timely delivery of your STEAM-IE kits. The shipping partner is selected 
            based on your location for optimal delivery experience.
          </p>

          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">6. Order Tracking</h2>
          <p className="text-gray-600 mb-6">
            Once your order is shipped, you will receive an email and SMS with the tracking number and 
            courier partner details. You can track your shipment through the courier&apos;s website or by 
            contacting our support team.
          </p>

          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">7. Delivery Instructions</h2>
          <p className="text-gray-600 mb-4">To ensure smooth delivery:</p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li>Provide accurate and complete delivery address with PIN code</li>
            <li>Include a working phone number for delivery coordination</li>
            <li>Ensure someone is available to receive the package</li>
            <li>Check the package for any visible damage before accepting</li>
          </ul>

          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">8. Damaged or Lost Shipments</h2>
          <p className="text-gray-600 mb-6">
            If your package arrives damaged or is lost in transit, please contact us within 48 hours of 
            delivery (or expected delivery date) with photos of the damage. We will arrange for a 
            replacement or refund as applicable. Please refer to our Refund Policy for more details.
          </p>

          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">9. School & Institutional Orders</h2>
          <p className="text-gray-600 mb-6">
            For bulk orders from schools and educational institutions, we offer special shipping 
            arrangements including scheduled delivery dates, consolidated shipments, and dedicated 
            support. Contact our institutional sales team at info@steamie.net for customized shipping 
            solutions.
          </p>

          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">10. Contact Us</h2>
          <p className="text-gray-600 mb-6">
            For shipping-related queries or assistance:<br />
            Email: info@steamie.net<br />
            Phone: +91 79966 97777<br />
            Hours: Monday - Saturday, 9:00 AM - 6:00 PM IST
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default ShippingPage;
